import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', function(){

  setTimeout(function(){

    new Swiper('.swiper-featured', {
      modules: [
        Navigation,
        Pagination,
        EffectFade,
      ],

      centeredSlides: false,
      spaceBetween:0,
      slidesPerView: 4,
      slidesPerGroup: 4,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          slidesPerGroup: 1,
        },
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        // when window width is >= 480px
        992: {
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
        // when window width is >= 640px
        1400: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      loop: true,
      effect: 'slide',
      fadeEffect: {
        crossFade: true,
      },
    });

  }, 100);

});



// WEBPACK FOOTER //
// ./scripts/autoload/_swiper.js